import {
    chakra,
    Flex,
    Box,
    Image
} from '@chakra-ui/react';

import newBadgeBackground from './assets/badge_background.svg';
import newBadgeAU from './assets/new_badge_en.png';
import newBadgeMX from './assets/new_badge_mx.png';
import { LandingBadgeVariants } from './landing-badge';

export const BadgeHeader = chakra('h2', {
    baseStyle: {
        fontSize: '20px',
        color: 'primary.700',
        m: '0'
    }
});

export const BadgeDescription = chakra('p', {
    baseStyle: {
        fontSize: '14px',
        color: 'neutral.600',
        m: '10px 0 0'
    }
});

export const BadgeSvgContainer = chakra(Box, { baseStyle: { marginRight: '20px' } });

export const BadgeSvg = chakra(Flex, {
    baseStyle: {
        justifyContent: 'center',
        bg: 'primary.50',
        w: '60px',
        h: '60px',
        borderRadius: '45px',
        position: 'relative',
        overflow: 'visible',
        ['svg, svg path']: {
            fill: 'var(--3p-colors-primary-500) !important',
            stroke: 'var(--3p-colors-primary-500) !important'
        }
    }
});

export const NewBadge = chakra(Image, {
    baseStyle: {
        display: 'inline',
        w: '95px',
        h: '95px',
        position: 'relative',
        top: '-42px',
        right: '20px',
        overflow: 'visible'
    }
});

export const BadgeItem = chakra(Box, {
    baseStyle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'hidden',
        bg: 'white',
        w: '440px',
        h: '125px',
        textAlign: 'left',
        p: '24px',
        m: '0 13px 20px',
        borderRadius: '16px',
        cursor: 'pointer',
        color: 'primary.700',
        textDecoration: 'unset',
        border: '1px solid',
        borderColor: 'primary.500',
        _hover: {
            transition: '0.2s ease',
            background: 'primary.50'
        }
    }
});

export const getBadgeItemStyles = (variant: LandingBadgeVariants) => {
    switch (variant) {
    case LandingBadgeVariants.new: {
        return {
            border: '3px solid',
            borderColor: 'primary.500',
            backgroundImage: newBadgeBackground,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            overflow: 'visible'
        };
    }
    default: return {};
    }
};

export const getBadgeHeaderStyles = (variant: LandingBadgeVariants) => {
    switch (variant) {
    case LandingBadgeVariants.new: {
        return {
            fontSize: '20px',
            color: 'primary.800',
            fontWeight: 500,
            letterSpacing: '-0.4px',
            width: '290px',
            padding: '5px 0px 0px 0px'
        };
    }
    default: return {};
    }
};

export const getBadgeDescriptionStyles = (variant: LandingBadgeVariants) => {
    switch (variant) {
    case LandingBadgeVariants.new: {
        return { lineHeight: '20px' };
    }
    default: return {};
    }
};

export const getBadgeImageSrc = (variant: LandingBadgeVariants, locale: string) => {
    switch (variant) {
    case LandingBadgeVariants.new: {
        if (locale.toLowerCase() === 'es-mx')
            return newBadgeMX;
        else
            return newBadgeAU;
    }
    default: return {};
    }
};
